<div class="widget-wrapper">

  <!-- <div class="supported-fundraiser" *ngIf="isMobile">
      <a href="" target="_blank" class="view-fundraisers-link">Click Here</a> to view fundraisers that you have supported on Ketto.
  </div> -->
  <div class="search-area" #searchBox (click)="onSearchClick($event)">
    <ais-search-box placeholder="Search for fundraiser" #focus></ais-search-box>
  </div>

  <!-- Option to open Filters component on Mobile -->
  <div class="filter-area" *ngIf="isMobile" (click)="openDialogFilter()">
    <span class="filter-txt">Filter Results</span>
    <span
      *ngIf="filterData.cause === 'All Categories' && filterData.tags === 'All Types' &&  filterData.address === 'All Locations'">
      <button mat-icon-button><mat-icon>tune</mat-icon></button>
    </span>
    <span
      *ngIf="filterData.cause !== 'All Categories' || filterData.tags !== 'All Types' ||  filterData.address !== 'All Locations'">
      <button class="selected-filter" mat-icon-button><mat-icon>tune</mat-icon></button>
    </span>
  </div>

  <div class="filter-area" *ngIf="!isMobile">
    <span class="filter-container">
      Showing fundraisers for
      <app-custom-filter (askLogin)="openLoginPopup('filter')" [attribute]="'category'" [filterData]="filterData"
        [origin]="'multipleFilters'"></app-custom-filter>
    </span>
    <span class="filter-container">
      under
      <app-custom-filter [attribute]="'tags'" (askLogin)="openLoginPopup('filter')" [filterData]="filterData"
        [origin]="'multipleFilters'"></app-custom-filter>
    </span>
    <span class="filter-container">
      from&nbsp;
      <app-custom-filter [attribute]="'address'" (askLogin)="openLoginPopup('filter')" [filterData]="filterData"
        [origin]="'multipleFilters'"></app-custom-filter>
    </span>
  </div>

  <div class="algolia-widget-container">
    <div *ngIf="!isMobile" class="reset-filter">
      <button (click)="!isLoggedIn ? askLogin.emit('filter'): $event.preventDefault()" mat-button>
        <ais-clear-refinements [ngClass]="{'prevent-click': !isLoggedIn}" resetLabel="Reset Filters" (click)="resetFilters()" />
      </button>
    </div>

    <ais-infinite-hits>
      <ng-template let-hits="hits" let-refineNext="showMore" let-isLastPage="isLastPage">

        <div class="widgetContainer">
          <ng-container *ngFor="let hit of hits; let i = index">
            <div class="widgetItem" *ngIf="i === 5 && vwo?.browse_fundraiser_random_campaign_AB()">
              <app-fundraiser-random-card [fundraisers]="hits"></app-fundraiser-random-card>
            </div>
            <div *ngIf="isLoggedIn || (!isMobile ? i < 6 : i < 3)" class="widgetItem">
              <app-fundraiser-card [fundraiser]="hit" theme="v3" [openInNewTab]="true" />
            </div>
            <div *ngIf="(isLoggedIn && (((i+1)%6 === 0 && !isMobile) || (((i+1)%3 === 0) && isMobile))) || (!isLoggedIn && ((((i+1) === 6) && !isMobile) || (((i + 1) === 3) && isMobile)))" class="sipPitch">
              <app-sip-nudge [user]="user"></app-sip-nudge>
            </div>
          </ng-container>
        </div>
        <div *ngIf="!isLoggedIn" class="blurredWrapper">
          <ng-container *ngTemplateOutlet="signinRef; context: { hits: hits }"></ng-container>
          <div class="widgetContainer blurred-bg">
            <ng-container *ngFor="let hit of hits; let i = index">
              <div *ngIf="(!isMobile ? i >= 6 : i >= 3) && (!isMobile ? i < 9 : i < 4)" class="widgetItem">
                <app-fundraiser-card [fundraiser]="hit" theme="v3" [noRedirect]="true" />
              </div>
            </ng-container>
          </div>
        </div>

        <div *ngIf="!isLastPage" class="showMore">
          <button (click)="isLoggedIn ? refineNext($event) : askLogin.emit('filter')" mat-button> Load More<i class="material-icons">expand_more</i></button>
        </div>

        <div class="no-results" *ngIf="hits.length === 0">
          <img loading="lazy" class="no-results-image" data-src="/assets/images/browse-campaign/no-results.png"
            alt="No Results">
          <div class="no-results-text">
            <span class="text1">No results found</span>
            <span class="text2">Try adjusting your search filters to find what you are looking for.</span>
          </div>
        </div>

      </ng-template>
    </ais-infinite-hits>

  </div>
</div>

<ng-template #signinRef let-hits="hits">
  <div [hidden]="(hits.length <= 6 && !isMobile) || (hits.length <= 3 && isMobile)" class="signin-wrapper">
    <div class="content">
      <div class="text">
        <div class="main-text">
          {{signinInfo?.mainTitle}}
        </div>
        <div class="desc">
          {{signinInfo?.desc}}
        </div>
      </div>
      <div class="signinSection">
        <app-signin-signup [isInline]="true" [numberOnly]="true" [noRedirectAfterLogin]="true" />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #randomAnimation let-hits="hits">
  <div [hidden]="(hits.length <= 6 && !isMobile) || (hits.length <= 3 && isMobile)" class="signin-wrapper">
    <div class="content">
      <div class="text">
        <div class="main-text">
          {{signinInfo?.mainTitle}}
        </div>
        <div class="desc">
          {{signinInfo?.desc}}
        </div>
      </div>
      <div class="signinSection">
        <app-signin-signup [isInline]="true" [numberOnly]="true" [noRedirectAfterLogin]="true" />
      </div>
    </div>
  </div>
</ng-template>